<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton( true, true );

</script>

<template>

    <div class="bg-white dark:bg-gray-900
                w-full h-full overflow-y-auto flex flex-col pb-12">
        
        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Cracked Windscreen</strong>
        </div>  

    </div>

</template>